import React from 'react';

import {FeatureFlagEnum} from 'src/api/ProactApiClient';
import {Stack} from 'src/design/atoms/Stack';
import {TasksOfflineBoundary} from 'src/app/tasks/TasksOfflineBoundary';
import {useConnectivity} from 'src/offline/useConnectivity';
import useActiveFeatureFlags from 'src/shared/hooks/useActiveFeatureFlags';
import {OpenCoursesView} from './components/OpenCoursesView/OpenCoursesView';
import {OpenTasksView} from './components/OpenTasksView/OpenTasksView';
import {PendingAccountSetup} from './components/PendingAccountSetup/PendingAccountSetup';

export const LandingPage: React.FC = () => {
  const {isOffline} = useConnectivity();
  const trainingEnabled = useActiveFeatureFlags().includes(
    FeatureFlagEnum.Training
  );

  // Open tasks are served from the cached tasks session offline; the
  // account-setup prompt is query-backed, so it is dropped.
  if (isOffline) {
    return (
      <TasksOfflineBoundary>
        <OpenTasksView />
      </TasksOfflineBoundary>
    );
  }

  return (
    <Stack gap="lg">
      <PendingAccountSetup />
      <OpenTasksView aside={trainingEnabled && <OpenCoursesView />} />
    </Stack>
  );
};

export default LandingPage;
